import React from "react";
import { Box, Typography } from "@mui/material";
import * as S from "./style";

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  details?: React.ReactNode;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, details, onClick }) => (
  <S.StyledStatPaper
    elevation={1}
    onClick={onClick}
    sx={{
      cursor: onClick ? "pointer" : "default",
    }}
  >
    <Typography sx={S.StyledStatLabel}>{label}</Typography>
    <Box sx={{ mt: 1 }}>
      <Typography sx={S.StyledStatValue}>{value}</Typography>
      {details ? <Typography sx={S.StyledStatDetail}>{details}</Typography> : null}
    </Box>
  </S.StyledStatPaper>
);

export default StatCard;
